import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ImageService } from '../../../services/image.service';
import { CurrentLanguage } from '../../../../../../Autofacets-Core/src/app/common-services/current-language.service';
import { UserDataService } from '../../../../../../../src/app/DataServices/user-data.service';
import * as Enums from '../../../../../../Autofacets-Core/src/app/utils/enums';
import { VehicleType } from '../../../business-entities/vehicle-list-view-model'
import { Constant } from '../../../../../../Autofacets-Core/src/app/utils/constant';
import { CheckListBusinessService } from '../../../business-services/check-list.service';

import { AddCategoryModel } from '../../../business-entities/category-list-model';
import { CategoryService } from '../../../business-services/category.service';

@Component({
  selector: 'app-add-category',
  templateUrl: './add-category.component.html',
})
export class AddCategoryComponent implements OnInit {

  category: AddCategoryModel =
    {
      categoryName: "",
      categoryDescription: "",
      encategoryName: "",
      decategoryName: "",
      nlcategoryName: "",
      createdBy: "",
      languageCode: '',
      id: 0
    };
  addCategory = false;
  addCategoryForm: FormGroup;
  allLanguage: any[];
  vehicleTypes: VehicleType[] = [];
  constructor(
    private formBuilder: FormBuilder,
    private categoryService: CategoryService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private translate: TranslateService,
    private currentLanguageService: CurrentLanguage,
    private activeModal: NgbActiveModal,
    private userService: UserDataService,
    private imageService: ImageService,
    private checkListService: CheckListBusinessService
  ) { }

  ngOnInit(): void {
    this.allLanguage = this.currentLanguageService.LanguageList;
    this.addCategoryForm = this.formBuilder.group({
      categoryDescription: new FormArray([]),
      categoryName: new FormArray([]),
      isActive: [true]
    });
    this.getLanguage();
    this.GetAllVehicleTypes();
  }

  get t() { return this.cpf.categoryName as FormArray; }
  get c() { return this.cpf.categoryDescription as FormArray; }

  getLanguage() {
    const number = this.currentLanguageService.LanguageList.length;
    if (this.t.length < number) {
      for (let i = this.t.length; i < number; i++) {
        this.t.push(this.formBuilder.group({
          languageId: ['', Validators.required],
          name: ['', Validators.required],
        }));
      }
    } else {
      for (let i = this.t.length; i >= number; i--) {
        this.t.removeAt(i);
      }
    }
    if (this.c.length < number) {
      for (let i = this.c.length; i < number; i++) {
        this.c.push(this.formBuilder.group({
          languageId: ['', Validators.required],
          description: ['', Validators.required],
        }));
      }
    } else {
      for (let i = this.c.length; i >= number; i--) {
        this.c.removeAt(i);
      }
    }
  }

  async GetAllVehicleTypes(): Promise<void> {
    await this.checkListService.getVehicleTypes().then(data => {
      if (localStorage.getItem("Theme") == Constant.BnhInterface) {
        this.vehicleTypes = data.responseObject;
      }
      else {
        this.vehicleTypes = data.responseObject.filter(x => x.isDisplay);
      }
    });
  }

  get cpf() {
    return this.addCategoryForm.controls;
  }


  addCategorys() {
    this.spinner.show();
    let currentUser = this.userService.currentUserValue.id;
    const viewModel = {
      ...this.addCategoryForm.value,
      createdBy: currentUser,
      // brandId: this.brandList.find(x => x.brandCode === this.addPreferencesForm.get('brand').value).id
    }
    this.categoryService.addEditCategory(viewModel).then(res => {
      if (res.responseCode === Enums.ErrorCodes.SuccessCode) {
        this.router.navigate(['category']);
        let successMsg = this.translate.instant("lblCategoryAdded");
        this.toaster.success(successMsg);
        this.activeModal.close({ success: true });
      }
      else if (res.responseCode === Enums.ErrorCodes.RentalCarAlreadyAdded) {
        this.spinner.hide();
        let errorErr = this.translate.instant("lblCategoryExist");
        this.toaster.warning(errorErr);
      }
    });
    this.spinner.hide();
  }
  OnClose() {
    this.activeModal.close({success: false})
  }
}
